import firebaseApp from "../firebase/credenciales";
import { getFirestore, collection, getDocs, query, where, orderBy } from "firebase/firestore";
const db = getFirestore(firebaseApp);

const inFlightByKey = new Map();

const buildKey = (baseDatos, ruc) => `${String(baseDatos || "")}:${String(ruc || "")}`;

export default async function getAllProducts(baseDatos, ruc) {
  const requestKey = buildKey(baseDatos, ruc);
  if (inFlightByKey.has(requestKey)) {
    return inFlightByKey.get(requestKey);
  }

  const loader = (async () => {
  const productosPorKey = new Map();
  const duplicadosPorDni = new Map();
  const collectionRef = collection(db, baseDatos);
  // Removemos el filtro de activo para traer todos los usuarios
  const q = query(collectionRef, where("rucEmpresa", "==", ruc), orderBy("apellidos"));
  const snapshot = await getDocs(q);

  snapshot.forEach((docSnap) => {
    const data = docSnap.data();
    if (data?.blacklistActive === true) return;

    const docId = String(docSnap.id || "").trim();
    const dni = String(data?.dni || "").trim().toUpperCase();
    const dedupeKey = dni || docId;
    const actual = { ...data, id: docId };

    if (!dedupeKey) return;

    const previo = productosPorKey.get(dedupeKey);
    if (!previo) {
      productosPorKey.set(dedupeKey, actual);
      return;
    }

    const yaDuplicados = duplicadosPorDni.get(dedupeKey) || [previo.id];
    yaDuplicados.push(actual.id);
    duplicadosPorDni.set(dedupeKey, yaDuplicados);

    const actualIdCoincideDni = Boolean(dni) && docId === dni;
    const previoIdCoincideDni = Boolean(dni) && previo.id === dni;

    if (actualIdCoincideDni && !previoIdCoincideDni) {
      productosPorKey.set(dedupeKey, actual);
      return;
    }

    if (actual.activo === true && previo.activo !== true) {
      productosPorKey.set(dedupeKey, actual);
    }
  });

  if (duplicadosPorDni.size > 0) {
    const resumenDuplicados = Array.from(duplicadosPorDni.entries()).map(([key, ids]) => ({
      dni: key,
      documentos: ids,
      cantidad: ids.length,
    }));
    console.warn("⚠️ Usuarios duplicados detectados por DNI/ID:", resumenDuplicados);
  }

  return Array.from(productosPorKey.values());
  })();

  inFlightByKey.set(requestKey, loader);

  try {
    return await loader;
  } finally {
    inFlightByKey.delete(requestKey);
  }
}
